import React from "react";

function index() {
  return <div>find a doctor</div>;
}

export default index;
